import Vue from 'vue';
import ApiClient from './base/ApiClient';

export default class MeetingsClient extends ApiClient {
    constructor($http) {
        super($http, Vue.prototype.$globalEnv.meetingsUrl, Vue.prototype.$globalEnv.baseUrlV2)
    }

    async join(meetingId) {
        try {
            var response = await this._get('v2/meeting/join', {meetingId})
            if(response)
                return response.url;
            return null;
        } catch {
            return null;
        }
    }

    getAttendances(meetingIds) {
        return this._get('v2/meetings/attendance', { meetingIds })
    }

    noShowReport(pagination, from, through) {
        const parameters = this.setPaginationDefaultsForUndefined(pagination);

        parameters.from = from;
        parameters.through = through;

        return this._get('api/attendance/no-show-report', parameters)
    }
    appointmentReport(pagination, from, through) {
        const parameters = this.setPaginationDefaultsForUndefined(pagination);

        parameters.from = from;
        parameters.through = through;

        return this._get('api/attendance/appointments', parameters)
    }
    appointmentRequestReport(pagination, from, through) {
        const parameters = this.setPaginationDefaultsForUndefined(pagination);

        parameters.from = from;
        parameters.through = through;

        return this._get('api/attendance/appointment-requests', parameters)
    }

    setPaginationDefaultsForUndefined(pagination){
        const limit = pagination.limit || 10
        const page = pagination.page || 1
        return {
            limit: limit,
            offset: (page - 1) * (limit),
            sortedColumn: pagination.sortedColumn || "",
            sortedAsc: pagination.sortedAsc
        }
    }

    getAppointmentsListCSV(filters) {
        return this._get('api/attendance/appointments-export', filters)
    }
}
